import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState } from "../const/consts";
import { RootState } from "../store";

const user = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUser: (
      state,
      { payload }: PayloadAction<Partial<typeof initialState>>,
    ) => ({
      ...state,
      ...payload,
    }),
    setName: (state, { payload }: PayloadAction<string>) => {
      state.name = payload;
    },
  },
});

export const { setUser, setName } = user.actions;

export const userDataSelector = (state: RootState) => state[user.name];
export const userNameSelector = (state: RootState) => state[user.name].name;
export const userLastNameSelector = (state: RootState) =>
  state[user.name].lastName;
export const userIdSelector = (state: RootState) => state[user.name].id;
export const userAgeSelector = (state: RootState) => state[user.name].age;

export default user;
